package horcrux.frontend.common.views.components.input

import kotlinx.browser.window
import mui.material.Link
import mui.material.LinkProps
import react.FC
import react.Props

external interface NewWindowLinkProps : Props {
    var url: String
    var linkProps: LinkProps
}

val NewWindowLink = FC<NewWindowLinkProps> { props ->
    Link {
        +props.linkProps
        this.href = props.url
        this.onClick = { event ->
            event.preventDefault()
            window.open(props.url, "_blank", "noreferrer")
            props.linkProps?.onClick?.invoke(event)
        }
    }
}
